export function filterBySearch<TData>(
  data: TData[],
  value: string,
  columnsToEnableSearchFor: string[] = [],
  onFilterData?: (data: TData[], searchValue: string) => TData[]
): TData[] {
  const trimmed = value.trim();

  if (trimmed === '') return data;

  if (onFilterData) return onFilterData(data, trimmed);

  if (columnsToEnableSearchFor.length > 0) {
    return data.filter((item: TData) => {
      return columnsToEnableSearchFor.some((columnKey) => {
        const columnValue = (item as unknown as Record<string, unknown>)[
          columnKey
        ];

        return (
          columnValue != null &&
          String(JSON.stringify(columnValue))
            .toLowerCase()
            .includes(trimmed.toLowerCase())
        );
      });
    });
  }

  // No-op here; caller should set global filter in table when columns are not specified
  return data;
}
